<script>
  import Chart from "chart.js/auto";
  import { onMount } from "svelte";

  let chartCanvas;

  export let chartAxes = "";
  export let chartDataSets;
  export let chartLabel = "label defaut...";

  const data = {
            labels: chartAxes,
            datasets: [
                {
                    label: chartLabel,
                    data: chartDataSets,
                    backgroundColor: [
                        "rgba(255, 99, 132)",
                        "rgba(54, 162, 235)",
                        "rgba(255, 206, 86)",
                        "rgba(75, 192, 192)",
                        "rgba(153, 102, 255)",
                        "rgba(255, 159, 64, 50)",
                        "rgba(255, 50, 64)",
                        "rgba(130, 80, 164)",
                        "rgba(180, 20, 100)",

                        ],
                        borderColor: [
                        "rgba(255, 99, 132, 1)",
                        "rgba(54, 162, 235, 1)",
                        "rgba(255, 206, 86, 1)",
                        "rgba(75, 192, 192, 1)",
                        "rgba(153, 102, 255, 1)",
                        "rgba(255, 159, 64, 1)",
                        "rgba(255, 50, 1)",
                        "rgba(130, 80, 1)",
                        "rgba(180, 20, 1)",
                        ],
                    // hoverOffset: 4,
                    borderWidth: 0
                }
            ]
        };

    const config = {
            type: 'pie',
            data: data,
            options: {
                responsive: true,
                cutout: 0,
                spacing: 0,
                plugins: {
                    legend: {
                        position: 'bottom',
                        display: true,
                        labels: {
                            usePointStyle: true,
                            padding: 20,
                            font: {
                                size: 14
                            }
                        }
                    },
                    title: {
                        display: true,
                        text: chartLabel
                    }
                }
            }
        };

    onMount(()=> {
        const ctx = chartCanvas.getContext('2d');
        // Initialize chart using default config set
        var myChart = new Chart(ctx, config);
      })

</script>
 <canvas bind:this={chartCanvas} width={400} height={400} />
